import Component from '@galactic-advisors/component-loader';

const DEFAULTS = {};

export default class UseIntercom extends Component {
  static selector = '[data-comp-intercom]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    this.apiUrl = this.$container.dataset.apiUrl;
    this.appId = this.$container.dataset.appId;
    this.userEmail = this.$container.dataset.email;
    this.userHash = this.$container.dataset.userHash;

    window.intercomSettings = {
      api_base: this.apiUrl,
      app_id: this.appId,
      email: this.userEmail,
      user_hash: this.userHash,
    };
  }

  init() {
    const intercom = window.Intercom;
    if (typeof intercom === 'function') {
      intercom('reattach_activator');
      intercom('update', window.intercomSettings);
    }

    const i = function (...args) {
      i.c(args);
    };

    i.q = [];
    i.c = function (...args) {
      i.q.push(args);
    };

    window.Intercom = i;

    const l = function () {
      const script = window.document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://widget.intercom.io/widget/ljkhgqlb';
      this.$container.parentNode.insertBefore(script, this.$container);
    };

    this.$container.addEventListener('load', l, false);
  }
}
